export function findClosestDate(date: Date | string, dates: Array<Date | string | undefined>): Date | null {
    const currentDate = new Date(date);

    if (Number.isNaN(currentDate.getTime())) {
        return null;
    }

    return dates
        .filter((d): d is string => !!d)
        .map(d => new Date(d))
        .filter(d => !Number.isNaN(d.getTime())) // Filter out invalid dates
        .filter(d => d >= currentDate) // Only include dates on or after currentDate
        .reduce<Date | null>((min, current) => (!min || current < min ? current : min), null);
}
